import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'plur... Remove this comment to see the full error message
import pluralize from 'pluralize';

import Card from 'src/components/Card';
import Button from 'src/components/Button';
import useGetRequest from 'src/hooks/useGetRequest';
import EmptyState from 'src/components/EmptyState';

const CardList = ({
  httpRequest,
  objects,
  objectType,
  isLoading,
  CardComponent,
  FormComponent,
  formProps
}: any) => {
  const [newIsOpen, setNewIsOpen] = React.useState(false);
  const [editIndex, setEditIndex] = React.useState(null);

  const newButton = (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; onClick: () => void; }' ... Remove this comment to see the full error message
    <Button onClick={() => setNewIsOpen(true)}>
      {`Add ${objectType}`}
    </Button>
  );

  if (isLoading) return null;

  if (!objects.length && !newIsOpen) {
    return (
      <EmptyState text={`No ${pluralize(objectType)} found.`}>
        {newButton}
      </EmptyState>
    );
  }

  return (
    <>
      {
      objects.map((item: any, i: any) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i}>
          <Box mt={2} />
          {
            i === editIndex ? (
              <Card>
                <FormComponent
                  onClose={() => setEditIndex(null)}
                  onSuccess={() => {
                    httpRequest();
                    setEditIndex(null);
                  }}
                  context={item}
                  {...formProps}
                />
              </Card>
            ) : (
              <div onClick={() => setEditIndex(i)}>
                <CardComponent item={item} />
              </div>
            )
          }
        </div>
      ))
    }
      {
      newIsOpen ? (
        <>
          <Box mt={2} />
          <Card>
            <FormComponent
              onClose={() => setNewIsOpen(false)}
              onSuccess={() => {
                httpRequest();
                setNewIsOpen(false);
              }}
              {...formProps}
            />
          </Card>
        </>
      ) : (
        <Box mt={2}>
          {newButton}
        </Box>
      )
    }
    </>
  );
};

export default CardList;
